import { useAgentChatHealthcheck } from "@ext/agent/components/store/AgentChatHealthcheckStore";
import useChatStore from "@ext/agent/components/store/ChatStore";

export const useChatComposerDisabled = () => {
	const inputDisabled = useChatStore((s) => s.isSending || s.sessionLoading || !s.activeSessionId || s.hydrating);
	const { status } = useAgentChatHealthcheck();
	return inputDisabled || status === "checking" || status === "unavailable";
};
